import Vue from 'vue'
import permission from './permission'

/**
 * 权限控制指令
 *
 * Usage: v-permission="权限配置"
 *
 * Description: 权限配置 格式如下 <String> :
 * 'material-page||(material-public&&material-private)'
 *  material-public为权限名称，例子中表达的意思是：当用户有material-page权限，或者同时有material-public和material-private权限时显示此元素
 */
Vue.directive('permission', permission)
